import React from 'react';
import { useNavigate } from 'react-router-dom';
import MapaCobertura from './MapaCobertura';
import './Cobertura.css';

const zonas = [
  "CDMX", "Estado de México", "Guadalajara", "Monterrey", "Puebla",
  "Querétaro", "Tijuana", "León", "Mérida", "Cancún",
  "Toluca", "Aguascalientes", "San Luis Potosí", "Chihuahua", "Morelia",
  "Veracruz", "Oaxaca", "Villahermosa", "Tuxtla Gutiérrez", "Pachuca"
];

export default function Cobertura() {
  const navigate = useNavigate();

  return (
    <div className="cobertura-page">

      <div className="cobertura-hero">
        <h1>📡 Mapa de Cobertura</h1>
        <p>
          Consulta nuestra cobertura en todo México. Verifica que tu zona
          tenga señal antes de contratar tu plan.
        </p>
      </div>

      <div className="cobertura-highlights">
        <div className="cobertura-highlight">
          <div className="cobertura-highlight-icon">🏙️</div>
          <h3>+50 ciudades</h3>
          <p>Cobertura en las principales zonas urbanas</p>
        </div>
        <div className="cobertura-highlight">
          <div className="cobertura-highlight-icon">📶</div>
          <h3>4G LTE</h3>
          <p>Velocidad de datos de alta velocidad</p>
        </div>
        <div className="cobertura-highlight">
          <div className="cobertura-highlight-icon">🗺️</div>
          <h3>Creciendo</h3>
          <p>Expandimos cobertura constantemente</p>
        </div>
      </div>

      <div className="cobertura-map-card">
        <p className="cobertura-map-title">Consulta tu cobertura en el mapa</p>
        <MapaCobertura />
      </div>

      <div className="cobertura-zones">
        <h2>Principales zonas con cobertura</h2>
        <div className="cobertura-zones-grid">
          {zonas.map((zona) => (
            <div key={zona} className="cobertura-zone-tag">{zona}</div>
          ))}
        </div>
      </div>

      <div className="cobertura-cta">
        <h3>🌎 También tenemos cobertura en USA y Canadá</h3>
        <p>Nuestros planes incluyen roaming en Estados Unidos y Canadá sin costo extra.</p>
      </div>

      <div className="cobertura-cta" style={{ marginTop: 16 }}>
        <h3>¿Viajas a otro país?</h3>
        <p>Compra nuestra eSIM Internacional y conéctate en más de 200 destinos al instante.</p>
        <button className="cobertura-cta-btn" onClick={() => navigate('/Ofertasinternacional')}>
          Ver eSIM Internacional
        </button>
      </div>

      <div className="cobertura-cta" style={{ marginTop: 16 }}>
        <h3>¿No encuentras tu zona?</h3>
        <p>Contáctanos y te ayudamos a verificar la cobertura en tu ubicación.</p>
        <button className="cobertura-cta-btn" onClick={() => navigate('/Mensajeria')}>
          Contactar soporte
        </button>
      </div>

    </div>
  );
}
